import { render } from "./SetAccountStatusForm.vue?vue&type=template&id=199b4270"
import script from "./SetAccountStatusForm.vue?vue&type=script&lang=js"
export * from "./SetAccountStatusForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__